import BaseEvent from "../../util/baseEvent"
import axios from "axios"
import Base64 from "../../util/Base64"
class ChooseEc extends BaseEvent {
  constructor(data) {
    super()
    this.pingFinished = false
    this.ecArray = [] // 存放ec节点数据
    this.tokenList = [...data] // 存放token数组
    // this.tokenList = [
    //   "eyJ0b2tlbklkIjoidGs2ZjFjMTIwNGY4NGNiMzUzOGYwMzIzMDMwMDk0N2FiYSIsImhvc3QiOiIxMC4xMDYuMTI4LjUyOjE4MDgwIiwic2VjdXJlIjpmYWxzZSwic2lnbmF0dXJlIjoiTnpnd05UQTNPVGN3T1RNMU5UQXdPR1U1Tm1Vd1pXSmxPR1EyT0RjNVlqa3hPVGszTnpreU1BPT0iLCJyb2xlIjoxLCJyb29tSWQiOiJqejA2MzNkMjliN2IzNjQ0Y2Q4MzJkNmE3YzI4MzdkYTg2IiwibWVkaWFDb25maWd1cmF0aW9uIjoiZGVmYXVsdCJ9",
    //   "eyJ0b2tlbklkIjoidGs2ZjFjMTIwNGY4NGNiMzUzOGYwMzIzMDMwMDk0N2FiYSIsImhvc3QiOiIxMC4xMDYuMTI4LjU2OjE4MDgwIiwic2VjdXJlIjpmYWxzZSwic2lnbmF0dXJlIjoiWWpKa01EbGhNRGs0WVRjNU16VTFNVGxrTlROaU16WXhaamcxTlRObVpqTmlOVE00TmpobU1RPT0iLCJyb2xlIjoxLCJyb29tSWQiOiJqejA2MzNkMjliN2IzNjQ0Y2Q4MzJkNmE3YzI4MzdkYTg2IiwibWVkaWFDb25maWd1cmF0aW9uIjoiZGVmYXVsdCJ9"
    // ]

    this.RaceLoop(this.tokenList)
  }
  RaceLoop(list) {
    let finishCount = 0
    const resolveHandler = res => {
      finishCount++
      if (finishCount >= list.length) {
        if (this.ecArray.length > 0) {
          this.pingFinished = true
          let bestEcIndex = res.sort(function(a, b) {
            return a.duration - b.duration
          })[0].ecIndex
          this.eventEmitter.emit("GET_EC_SUCCESS", bestEcIndex)
        } else {
          // 没有可用的EC节点
          this.eventEmitter.emit("GET_EC_FAILED", "no valid ec")
        }
      }
    }
    list.forEach((item, index) => {
      let ec = JSON.parse(Base64.decodeBase64(item)).host.split(":")[0]
      this.pingLoop(ec, index).then(resolveHandler)
    })
  }
  pingLoop(ec, index) {
    return new Promise((resolve, reject) => {
      let strTime = Date.now()
      this.ping(ec)
        .then(() => {
          this.ecArray.push({
            ec,
            ecIndex: index,
            duration: Date.now() - strTime
          })
          resolve(this.ecArray)
        })
        .catch(error => {
          resolve(this.ecArray)
        })
    })
  }
  ping(ec) {
    return axios(`https://${ec}:18443/ping`, { timeout: 3000 })
  }
}

export default ChooseEc
